import { css, SerializedStyles } from '@emotion/core';
import {
  Theme,
  helpText,
  titleText,
  normalText,
  secondaryText,
} from 'features/Theme';

const styles = {
  headingContainer: (theme: Theme): SerializedStyles => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  body: (theme: Theme) => css`
    ${normalText(theme)}
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  titleText: (theme: Theme): SerializedStyles => css`
    ${titleText(theme)};
    color: ${theme.mui.palette.text.secondary};
    text-align: center;
  `,
  finePrint: (theme: Theme): SerializedStyles => css`
    ${helpText(theme)};
    margin: ${theme.mui.spacing(1)}px 0 ${theme.mui.spacing(1)}px;
  `,
  restartText: (theme: Theme): SerializedStyles => css`
    ${secondaryText(theme)};
  `,
  actionsContainer: (theme: Theme) => css`
    margin-top: ${theme.mui.spacing(3)}px;
  `,
};

export default styles;
